import { makeStyles } from "@material-ui/core/styles";


const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        background: "linear-gradient(0deg, #141329 68.55%, #000000 99.48%)",
        justifyContent: "center",
    },
    container: {
        width: "100%",
        maxWidth: "1366px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        [theme.breakpoints.up('md')]: {
            margin: '0 96px',
            paddingBottom: 56,
            paddingTop: 26
        },
        [theme.breakpoints.down('md')]: {
            margin: '0 24px',
            paddingBottom: 40,
        },
    },
    ratingContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: '38px',
        flexDirection: 'row',
        gap: '20px',
        [theme.breakpoints.down('md')]: {
            flexDirection: 'column',
            marginTop: '32px',
            // gap: '16px',
        },
        [theme.breakpoints.down('xs')]: {
            gap: '12px',
            marginTop: '24px',
        },
    },
    rating: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        '& > img': {
            // ratingIcon original ratio: 1332 × 376, rasio: 1332/376 = 3.5425
            height: '93px',
            width: '329px', // 93px * 3.5425 = 329.45px ≈ 329px
            objectFit: 'contain',
            [theme.breakpoints.down('sm')]: {
                height: '69px',
                width: '244px' // 69px * 3.5425 = 244.43px ≈ 244px
            },
        },
    },
    award: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        '& > img': {
            // AwardIcon dimensi: 500 × 376, rasio: 500/376 = 1.33
            // Height disesuaikan dengan ratingIcon: 93px (desktop), 69px (mobile)
            height: '93px', // Same height as ratingIcon
            width: '124px', // 93px * 1.33 = 123.69px ≈ 124px
            objectFit: 'contain',
            [theme.breakpoints.down('sm')]: {
                height: '69px', // Same height as ratingIcon mobile
                width: '92px' // 69px * 1.33 = 91.77px ≈ 92px
            },
        },
    },
    awardV2: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        '& > img': {
            // AwardIconV2 dimensi: 816 × 376, rasio: 816/376 = 2.17
            // Height disesuaikan dengan ratingIcon: 93px (desktop), 69px (mobile)
            height: '93px', // Same height as ratingIcon
            width: '202px', // 93px * 2.17 = 201.81px ≈ 202px
            objectFit: 'contain',
            [theme.breakpoints.down('sm')]: {
                height: '69px', // Same height as ratingIcon mobile
                width: '150px' // 69px * 2.17 = 149.73px ≈ 150px
            },
        },
    },
    awardV3: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        '& > img': {
            // awardIconV3 original size: 624 × 376, rasio: 624/376 = 1.6596
            // Height disesuaikan dengan ratingIcon: 93px (desktop), 69px (mobile)
            height: '93px',
            width: '154px', // 93px * 1.6596 = 154.34px ≈ 154px
            objectFit: 'contain',
            [theme.breakpoints.down('sm')]: {
                height: '69px',
                width: '115px' // 69px * 1.6596 = 114.51px ≈ 115px
            },
        },
    },
    ctnTitle: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        paddingTop: 24
    },
    title: {
        margin: 0,
        fontSize: '60px',
        fontWeight: '900',
        color: '#fff',
        textAlign: 'center',
        lineHeight: '80px',
        [theme.breakpoints.down('md')]: {
            fontSize: '36px',
            lineHeight: '48px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '35px',
            lineHeight: '50px',
        },
    },
    gradientText: {
        background: "linear-gradient(to right, #1B7AED 0%, #9048D8 70%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        backgroundClip: "text",
        textFillColor: "transparent",
    },
    subTitle: {
        fontSize: '26px',
        fontWeight: '600',
        color: '#D1D5DB',
        textAlign: 'center',
        lineHeight: '32px',
        marginTop: '12px',
        marginBottom: '28px',
        [theme.breakpoints.up('md')]: {
            marginBottom: 36,
            marginTop: 16
        },
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
        },
        [theme.breakpoints.down(370)]: {
            fontSize: 17
        }
    },
    heroImage: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '48px',
        '& picture': {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '100%',
        },
        '& img': {
            width: '100%',
            height: '100%',
            maxHeight: 520,
            objectFit: 'contain',
        },
        [theme.breakpoints.down('sm')]: {
            marginTop: 44
        }
    },
    ctnLanguageDesktop: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    ctnLanguageMobile: {
        background: '#000',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '16px 0',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        [theme.breakpoints.down('sm')]: {
            padding: '6px 24px 16px 24px',
        },
    },
    breakDesktop: {
        [theme.breakpoints.down('md')]: {
            display: 'none',
        },
    },
    breakMobile: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    heroImageDesktop: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    heroImageMobile: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    mainContainer: {
        paddingTop: 80,
        [theme.breakpoints.down('md')]: {
            paddingTop: 62
        }
    },



    ctnButton: {
        '& > button': {
            animation: "$pulse-animation 2s infinite",
        }
    },

    "@keyframes pulse-animation": {
        "0%": {
            boxShadow: "0 0 0 0 rgba(59, 82, 252, 0.9)",
        },
        "100%": {
            boxShadow: "0 0 0 14px rgba(59, 82, 252, 0)",
        },
    },
    hideMobile: {
        [theme.breakpoints.down('sm')]: {
            display: 'none',
        },
    },
    hideDesktop: {
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
}));

export default useStyles;